/**
 * @file
 * Vue app for faq like.
 */

'use strict';

import Vue from 'vue';
import axios from 'axios';

Vue.component('like', {
  props: {
    nid: Number,
    inputCount: Number,
  },
  data() {
    return {
      count: 0,
      choosen: false,
      loading: false,
      rendered: false,
    }
  },
  methods: {
    makeLike(type) {
      if (this.choosen === type || this.loading) {
        return;
      }

      localStorage['node-likes-' + this.nid] = type;
      if (!this.choosen && type === -1) {
        this.choosen = -1;
        return;
      }

      this.choosen = type;
      this.count = this.count + type;
      this.loading = true;
      axios.post('/api/faq/like/' + this.nid, {
        like: type,
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        alert('Произошла ошибка');
      });
    },
  },
  created() {
    this.rendered = true;
    this.count = this.inputCount;
  },
  mounted() {
    if (localStorage['node-likes-' + this.nid]) {
      this.choosen = localStorage['node-likes-' + this.nid];
    }
  },
});

new Vue({
  delimiters: ['${', '}'],
  comments: true,
  el: '#faq-like',
  methods: {
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
  },
});
